<template>
    <v-container
        v-resize="onResize"
        fluid
        class="overflow-y-hidden pa-3"
        ref="container"
        style="height:100%"
    >
        <v-progress-linear v-if="loading" indeterminate color="primary" />
        <v-data-table
            v-else
            id="virtual-scroll-table"
            disable-pagination
            hide-default-footer
            :headers="headers"
            :items="sortedItems"
            :mobile-breakpoint="0"
            :height="height"
            item-key="id"
            class="elevation-0"
            :loading="loading"
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    :style="{ 'background-color': '#eeeeee' }"
                    :class="
                        $vuetify.breakpoint.xs
                            ? 'mt-0 mx-0 pt-3 pb-0 pb-3 align-center'
                            : 'mt-0 mx-0 pt-3 pb-0 pb-3 align-center'
                    "
                >
                    <v-col cols="12" class="d-flex">
                        <h2 class="ml-4">EVALUATIONS</h2>
                        <v-spacer v-if="!$vuetify.breakpoint.xs" />
                        <v-btn
                            color="primary"
                            class="mr-4"
                            :loading="reportLoading"
                            @click="downloadReport"
                        >
                            Report
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.evaluationType`]="{ header }">
                <v-text-field
                    class="py-2 mt-2 custom-label"
                    :label="header.text"
                    v-model="typeToFilter"
                    dense
                />
            </template>
            <template v-slot:[`header.supplier`]="{ header }">
                <v-text-field
                    class="py-2 mt-2 custom-label"
                    :label="header.text"
                    v-model="supplierToFilter"
                    dense
                />
            </template>
            <!-- ITEMS -->
            <template v-slot:[`item.date`]="{ item }">
                <p class="my-0">
                    {{
                        formatDate(
                            item.date.seconds
                                ? item.date.seconds
                                : item.date._seconds
                        )
                    }}
                </p>
            </template>
            <template v-slot:[`item.evaluationType`]="{ item }">
                <p class="my-0">
                    {{
                        item.evaluationType === 'initial'
                            ? 'Initial'
                            : item.evaluationType === 'reevaluation'
                            ? 'Re-evaluation'
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.supplier`]="{ item }">
                <p class="my-0">
                    {{ item.supplier?.name || '' }}
                </p>
            </template>
            <template v-slot:[`item.purchasingEdit`]="{ item }">
                <p class="my-0">
                    {{
                        item.purchasingEdit
                            ? getUserName(item.purchasingEdit)
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.warehouseEdit`]="{ item }">
                <p class="my-0">
                    {{
                        item.warehouseEdit
                            ? getUserName(item.warehouseEdit)
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.sstEdit`]="{ item }">
                <p class="my-0">
                    {{ item.sstEdit ? getUserName(item.sstEdit) : '' }}
                </p>
            </template>
            <template v-slot:[`item.environmentalEdit`]="{ item }">
                <p class="my-0">
                    {{
                        item.environmentalEdit
                            ? getUserName(item.environmentalEdit)
                            : ''
                    }}
                </p>
            </template>
            <template v-slot:[`item.totalScore`]="{ item }">
                <td
                    :style="
                        `background-color: ${getColorPerformance(
                            (item.purchasingScore || 0) +
                                (item.warehouseScore || 0) +
                                (item.sstScore || 0) +
                                (item.environmentalScore || 0)
                        )} !important`
                    "
                >
                    <p class="white--text text-center my-0">
                        {{
                            (item.purchasingScore || 0) +
                                (item.warehouseScore || 0) +
                                (item.sstScore || 0) +
                                (item.environmentalScore || 0)
                        }}
                    </p>
                </td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                    small
                    @click="openPDF(item)"
                    v-if="
                        item.warehouseClosed &&
                            item.sstClosed &&
                            item.purchasingClosed &&
                            item.environmentalClosed &&
                            item.supplier.name &&
                            user.permissions.includes('evaluateSupplier')
                    "
                >
                    mdi-file-pdf-box
                </v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import ExcelJS from 'exceljs'
import API from '@/services/api'
import moment from 'moment'
import { printEvaluationPDF } from './ReportEvaluationSupplier'

export default {
    name: 'SuppliersEvaluations',
    components: {},
    data: () => ({
        height: 0,
        loading: false,
        items: [],
        headers: [
            {
                text: 'Date',
                value: 'date',
                align: 'center',
                sortable: false,
                width: '120',
            },
            {
                text: 'Type of Evaluation',
                value: 'evaluationType',
                align: 'center',
                sortable: false,
                width: '120',
            },
            {
                text: 'Supplier',
                value: 'supplier',
                align: 'center',
                sortable: false,
                width: '120',
            },
            {
                text: 'Purchasing Evaluator',
                value: 'purchasingEdit',
                align: 'center',
                sortable: false,
                width: '120',
            },

            {
                text: 'Warehouse Evaluator',
                value: 'warehouseEdit',
                align: 'center',
                sortable: false,
                width: '120',
            },

            {
                text: 'SST Evaluator',
                value: 'sstEdit',
                align: 'center',
                sortable: false,
                width: '120',
            },

            {
                text: 'Environmental Evaluator',
                value: 'environmentalEdit',
                align: 'center',
                sortable: false,
                width: '120',
            },

            {
                text: 'Score',
                value: 'totalScore',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'Actions',
                value: 'actions',
                align: 'center',
                sortable: false,
                width: '50',
            },
        ],
        typeToFilter: null,
        supplierToFilter: null,
        reportLoading: false,
        companyId: JSON.parse(localStorage.getItem('company')),
        user: {},
        users: [],
        suppliers: [],
    }),
    async mounted() {
        try {
            this.loading = true
            const {
                data: { user },
            } = await API.getMyInfo()
            this.user = user
            const {
                data: { users },
            } = await API.getLiteUsers()
            this.users = users
            this.suppliers = await API.getSuppliers()
            this.items = await API.getEvaluationsSuppliers({})
            await this.getSuppliersInfo()

            this.onResize()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    updated() {
        this.onResize()
    },
    computed: {
        filteredItems() {
            let conditions = []

            if (this.typeToFilter) {
                conditions.push(this.filterByType)
            }

            if (this.supplierToFilter) {
                conditions.push(this.filterBySupplier)
            }

            if (conditions.length > 0) {
                return this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }

            return this.items
        },
        sortedItems() {
            return [...this.filteredItems].sort((a, b) => {
                const aDate = a.date?.seconds || a.date?._seconds || 0
                const bDate = b.date?.seconds || b.date?._seconds || 0
                return bDate - aDate
            })
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD')
        },
        filterBySupplier(item) {
            return (item.supplier?.name || '')
                .toLowerCase()
                .includes(this.supplierToFilter.toLowerCase())
        },
        filterByType(item) {
            return item.evaluationType
                .toLowerCase()
                .includes(this.typeToFilter.toLowerCase())
        },
        formatNumber(currency, value) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency,
                maximumFractionDigits: currency == 'USD' ? 2 : 0,
            }).format(parseFloat(value))
        },
        getUserName(id) {
            if (this.users.length > 0 && id) {
                return this.users.find(user => user.id == id)?.name
            } else {
                return ''
            }
        },
        getSuppliersInfo() {
            const supplierMap = {}
            this.suppliers.forEach(s => {
                supplierMap[s.id] = {
                    id: s.id,
                    name: s.name,
                    nit: s.nit,
                }
            })
            this.items = this.items.map(item => ({
                ...item,
                supplier: supplierMap[item.supplierId] || {},
            }))
        },
        getColorPerformance(performance) {
            const convertNumber = Number(performance)
            if (isNaN(convertNumber)) return '#ccc'
            if (convertNumber >= 80) return '#8BC34A'
            if (convertNumber >= 60) return '#FFEB3B'
            return '#F44336'
        },
        async openPDF(item) {
            try {
                this.loading = true
                const questionsForm = await API.getSupplierQuestions({
                    language: 'spanish',
                })
                const blob = await printEvaluationPDF(
                    questionsForm,
                    item,
                    item.supplier,
                    false
                )
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `supplier_evaluation_${item.supplier?.name ||
                    ''}_${item.evaluationType || ''}.pdf`
                a.click()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        onResize() {
            const {
                container: { clientHeight: containerHeight },
            } = this.$refs
            this.height = containerHeight - 180
        },
        answerToScore(value) {
            if (value === 'YES') return 1
            if (value === 'NO') return 0
            if (value === 'PARTIALLY' || value === 'PARTIAL') return 0.5
            return ''
        },
        getCreatedOnSeconds(item) {
            return (
                item.createdOn?.seconds ??
                item.createdOn?._seconds ??
                item.date?.seconds ??
                item.date?._seconds
            )
        },
        groupedQuestionsByCategory(questions) {
            const safe = Array.isArray(questions) ? questions : []
            const order = []
            const groups = {}
            safe.forEach(q => {
                if (!groups[q.category]) {
                    groups[q.category] = []
                    order.push(q.category)
                }
                groups[q.category].push(q)
            })
            return order.map(cat => ({ category: cat, questions: groups[cat] }))
        },
        async downloadReport() {
            try {
                this.reportLoading = true
                const currentYear = new Date().getFullYear()
                const itemsForReport = this.items.filter(item => {
                    const completed =
                        item.warehouseClosed &&
                        item.sstClosed &&
                        item.purchasingClosed &&
                        item.environmentalClosed &&
                        !!item.supplier?.name
                    if (!completed) return false
                    const sec = this.getCreatedOnSeconds(item)
                    if (!sec) return false
                    return new Date(sec * 1000).getFullYear() === currentYear
                })

                const questionsForm = await API.getSupplierQuestions({
                    language: 'spanish',
                })
                const categoriesWithQuestions = this.groupedQuestionsByCategory(
                    questionsForm
                )

                const fixedCols = [
                    'Date',
                    'Type of evaluation',
                    'Supplier',
                    'Purchasing Evaluator',
                    'Warehouse Evaluator',
                    'SST Evaluator',
                    'Environmental Evaluator',
                    'Score',
                ]
                const numFixedCols = fixedCols.length
                const scoreColIndex = 8

                const headerRow1 = []
                const headerRow2 = []
                const mergeRanges = []

                fixedCols.forEach(col => {
                    headerRow1.push('')
                    headerRow2.push(col)
                })

                let colIndex = numFixedCols
                for (const { category, questions } of categoriesWithQuestions) {
                    const startCol = colIndex + 1
                    for (const q of questions) {
                        headerRow1.push(category)
                        headerRow2.push(q.question ?? q.variable ?? '')
                        colIndex++
                    }
                    headerRow1.push(category)
                    headerRow2.push('subtotal')
                    colIndex++
                    mergeRanges.push({
                        start: startCol,
                        end: colIndex,
                    })
                }

                const dataRows = itemsForReport.map(item => {
                    const createdOnSec = this.getCreatedOnSeconds(item)
                    const dateStr = createdOnSec
                        ? this.formatDate(createdOnSec)
                        : ''
                    const typeLabel =
                        item.evaluationType === 'initial'
                            ? 'Initial'
                            : item.evaluationType === 'reevaluation'
                            ? 'Re-evaluation'
                            : ''
                    const totalScore =
                        (item.purchasingScore || 0) +
                        (item.warehouseScore || 0) +
                        (item.sstScore || 0) +
                        (item.environmentalScore || 0)

                    const row = [
                        dateStr,
                        typeLabel,
                        item.supplier?.name || '',
                        this.getUserName(item.purchasingEdit),
                        this.getUserName(item.warehouseEdit),
                        this.getUserName(item.sstEdit),
                        this.getUserName(item.environmentalEdit),
                        totalScore,
                    ]

                    for (const { questions } of categoriesWithQuestions) {
                        let subtotal = 0
                        for (const q of questions) {
                            const score = this.answerToScore(item[q.variable])
                            const num =
                                score === ''
                                    ? 0
                                    : typeof score === 'number'
                                    ? score
                                    : 0
                            subtotal += num
                            row.push(score === '' ? '' : score)
                        }
                        row.push(subtotal)
                    }
                    return { row, totalScore }
                })

                const workbook = new ExcelJS.Workbook()
                const worksheet = workbook.addWorksheet('Evaluations')
                const hexToArgb = hex =>
                    `FF${String(hex)
                        .replace('#', '')
                        .padEnd(6, '0')
                        .slice(0, 6)}`

                worksheet.addRow(headerRow1)
                worksheet.addRow(headerRow2)

                for (const { row } of dataRows) {
                    worksheet.addRow(row)
                }

                const totalCols = headerRow1.length
                for (let c = 1; c <= totalCols; c++) {
                    const cell1 = worksheet.getCell(1, c)
                    const cell2 = worksheet.getCell(2, c)
                    cell1.font = { ...cell1.font, bold: true }
                    cell2.font = { ...cell2.font, bold: true }
                }

                for (const { start, end } of mergeRanges) {
                    if (end > start) {
                        worksheet.mergeCells(1, start, 1, end)
                    }
                }

                const scoreBgColor = score =>
                    this.getColorPerformance(score).replace(
                        /^#?([0-9A-Fa-f]{3})$/,
                        (_, h) => `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`
                    )
                dataRows.forEach(({ totalScore }, i) => {
                    const excelRow = 3 + i
                    const cell = worksheet.getCell(excelRow, scoreColIndex)
                    const bg = scoreBgColor(totalScore)
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: hexToArgb(bg) },
                    }
                    cell.font = {
                        ...cell.font,
                        color: { argb: 'FFFFFFFF' },
                    }
                })

                const buffer = await workbook.xlsx.writeBuffer()
                const blob = new Blob([buffer], {
                    type:
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                })
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `evaluations_report_${currentYear}.xlsx`
                a.click()
                URL.revokeObjectURL(url)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.reportLoading = false
            }
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead th {
    background-color: #eeeeee !important;
}
.custom-label .v-label {
    font-size: 12px;
}
#virtual-scroll-table {
    width: 100%;
    overflow-y: auto;
}
</style>
